(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("fs"));
	else if(typeof define === 'function' && define.amd)
		define(["fs"], factory);
	else if(typeof exports === 'object')
		exports["memoryViz"] = factory(require("fs"));
	else
		root["memoryViz"] = factory(root["fs"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__947__) => {
return 